import axios from "axios";
import Cookies from "js-cookie";
import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Breadcrumb, Card, CardBody, CardHeader, Container } from "reactstrap";

import { refresh } from "../../../store/adminSlice";
import AutoOrderTable from "./AutoOrderTable";

const AutoOrderList = () => {
  const [datas, setDatas] = useState([]);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const toastMessage = useLocation();

  useEffect(() => {
    if (toastMessage.state && toastMessage?.state?.message) {
      toast.success(toastMessage.state.message);
    }
  }, [toastMessage.state]);

  useEffect(() => {
    async function search() {
      await axios
        .get(`/alibaba/api/v1/crossOrder/`)
        .then((res) => setDatas(res.data))
        .catch((e) => {
          console.log(e);
          if (e.response?.status === 401 && Cookies.get("logss")) {
            dispatch(refresh()).then(() => search());
          } else if (e.response?.status === 401 && !Cookies.get("logss")) {
            navigate("/");
          } else {
            toast.error("Error occurred");
          }
        });
    }
    const timeout = setTimeout(() => search(), 850);
    return () => clearTimeout(timeout);
  }, [dispatch, navigate, query]);

  return (
    <Fragment>
      <Breadcrumb title="Orders List" parent="Orders" />
      <Container fluid={true}>
        <Card>
          <CardHeader>
            <h5>Orders List</h5>
          </CardHeader>
          <CardBody>
            <div className="clearfix"></div>
            <div
              id="batchDelete"
              className="category-table user-list order-table coupon-list-delete"
            >
              {datas?.results && (
                <AutoOrderTable
                  myData={datas}
                  hideFields={["items"]}
                  apiLink={"/alibaba/api/v1/crossOrder/?page="}
                />
              )}
            </div>
          </CardBody>
        </Card>
      </Container>
      <ToastContainer />
    </Fragment>
  );
};

export default AutoOrderList;
